import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { SingleReport, SingleReportProps } from './single-report/single-report';

export interface ReportsListProps {
  data: SingleReportProps[];
  status: LoadingState;
}

export const ReportsList = types
  .model({
    data: types.optional(types.array(SingleReport), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: ReportsListProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setReports(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.reportsList,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setReports();
    },
    async update(): Promise<void> {
      await self.setReports();
    },
  }))
  .views((self) => ({
    getRecentReports(size = 6): SingleReportProps[] {
      const { data } = self;
      return getSnapshot(data).slice(0, size);
    },
    getReports(): SingleReportProps[] {
      const { data } = self;
      return getSnapshot(data);
    },
  }));

export const reportsList = ReportsList.create();
export type ReportsListSnapshot = SnapshotIn<typeof ReportsList>;
export type ReportsListInstance = Instance<typeof ReportsList>;
export default reportsList;
